import {LinkIcon, PlusIcon, TriangleDownIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Button} from '@primer/react'
import {useCallback, useState} from 'react'

import {useCreateArtifactDialog} from './use-create-artifact-dialog'

type CreateArtifactMenuButtonProps = {
  resourceId?: number | null
}

export function CreateArtifactMenuButton({resourceId}: CreateArtifactMenuButtonProps) {
  const [menuOpen, setMenuOpen] = useState(false)
  const {
    createArtifactDialog,
    openCreateArtifactDialog,
    openCreateLinkDialog,
    resourceIdIsReady,
    triggerRef: addArtifactButtonRef,
  } = useCreateArtifactDialog({resourceId})

  const handleMenuOpenChange = useCallback(
    (open: boolean) => {
      setMenuOpen(resourceIdIsReady && open)
    },
    [resourceIdIsReady],
  )

  const handleCreateArtifact = useCallback(() => {
    if (!resourceIdIsReady) return
    setMenuOpen(false)
    openCreateArtifactDialog()
  }, [openCreateArtifactDialog, resourceIdIsReady])

  const handleCreateLink = useCallback(() => {
    if (!resourceIdIsReady) return
    setMenuOpen(false)
    openCreateLinkDialog()
  }, [openCreateLinkDialog, resourceIdIsReady])

  return (
    <>
      <ActionMenu anchorRef={addArtifactButtonRef} open={menuOpen} onOpenChange={handleMenuOpenChange}>
        <ActionMenu.Anchor>
          <Button type="button" size="small" trailingVisual={TriangleDownIcon} aria-disabled={!resourceIdIsReady}>
            Add artifact
          </Button>
        </ActionMenu.Anchor>
        <ActionMenu.Overlay>
          <ActionList>
            <ActionList.Item onSelect={handleCreateLink}>
              <ActionList.LeadingVisual>
                <LinkIcon />
              </ActionList.LeadingVisual>
              Add link
            </ActionList.Item>
            <ActionList.Divider />
            <ActionList.Item onSelect={handleCreateArtifact}>
              <ActionList.LeadingVisual>
                <PlusIcon />
              </ActionList.LeadingVisual>
              Create artifact
            </ActionList.Item>
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
      {createArtifactDialog}
    </>
  )
}
